import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { IIndexable, SettingsDTO } from "src/app/shared/interfaces/settings/setting.interface";
import { API_ENDPOINTS, API_URL } from 'src/app/shared/utils/globals';
import { parseJson } from "src/app/shared/utils/util-function";
import { ApiHandlerService } from '../api-handler.service';
@Injectable({
  providedIn: 'root'
})
export class SettingService {

  constructor(private apiService: ApiHandlerService) { }

  async getSettingList(CompanyName:string) {
    return (await lastValueFrom(this.apiService.Get(API_URL + API_ENDPOINTS.getSettings + `/${CompanyName}`)))?.Response
  }


  mapSettingValues(
    settingList: SettingsDTO[],
    mapSettings: any,
    returnValueIfUndefined: any = null
  ): any {
    let mapValue: any;
    Object.entries(settingList).forEach(([key, setting]) => {
      if (typeof mapSettings == 'object') {
        if ((mapSettings as IIndexable)[setting.Name] !== undefined) {
          (mapSettings as IIndexable)[setting.Name] = parseJson(setting.Value);
        }

        if (
          mapSettings.Children &&
          (mapSettings.Children as IIndexable)[setting.Name] !== undefined
        ) {
          (mapSettings.Children as IIndexable)[setting.Name] = parseJson(
            setting.Value
          );
        }

        mapValue = { ...mapSettings };
      } else {
        if (setting.Name == mapSettings) {
          mapValue = parseJson(setting.Value);
        }
      }
    });

    //if mapValue is undefined it means no value is found in the settingList
    if (mapValue == undefined) {
      if (returnValueIfUndefined != null) {
        return parseJson(returnValueIfUndefined);
      } else {
        return mapSettings;
      }
    }

    return mapValue;
  }
}
